export default "__VITE_ASSET__C_FdSNNB__"